import { render } from "./NetlifyRecaptcha.vue?vue&type=template&id=edc67794"
import script from "./NetlifyRecaptcha.vue?vue&type=script&lang=js"
export * from "./NetlifyRecaptcha.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__